import { Observable, Subject } from 'rxjs';
import { BaseUxGameListener } from './base-ux-game-listener';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { SolitaireListener } from 'src/games/phasersolitaire/game/solitaire-listener';

export class SolitaireUxGameListener extends BaseUxGameListener implements SolitaireListener {
  public get noMoreHints$(): Observable<void> {
    return this.noMoreHints.asObservable();
  }

  private noMoreHints = new Subject<void>();

  constructor(private services: UxGameServices) {
    super();
  }

  showNoMoreHintsPopup(): void {
    this.noMoreHints.next();
  }
}
